import styled from 'styled-components'
import { Button } from '@gnosis.pm/safe-react-components'

export const ChainList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const ChainItem = styled(Button)<{ $isActive?: boolean }>`
  border-radius: 8px;
  padding: 8px;
  min-width: 250px !important;
  &:not(:disabled) {
    background-color: transparent;
    color: ${(props) => props.theme.colors.primary};
    border: 1px solid ${(props) => props.theme.colors.primary};
    ${(props) => {
      if (props.$isActive) {
        return `
            background-color: ${props.theme.colors.primary};
                  color: ${props.theme.colors.white};
                    `
      }
    }}
    &:hover {
      background-color: ${(props) => props.theme.colors.primary};
      color: ${(props) => props.theme.colors.white};
    }
  }
`
export const WalletContainer = styled.div`
  padding: 30px 0;
  padding-left: 45px;

  > button {
    margin: auto;
  }
`
export const WalletDivider = styled.div`
  margin-top: 10px;
  @media (max-width: 600px) {
    display: flex;
    justify-content: center;
  } ;
`

export const NetworkLabelDivider = styled.div`
  @media (max-width: 600px) {
    display: flex;
    justify-content: center;
  }
`
